import styled from '@emotion/styled';

export const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;
